<template>
  <div v-if="contents" class="mark-down-sb" v-html="sanitizedMarkdown"></div>
</template>

<script>
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

export default {
  name: 'MdSb',
  props: {
    contents: { type: String, default: '' }
  },
  data() {
    return {
      md: new MarkdownIt({
        html: true,
        breaks: true,
        linkify: true
      })
    };
  },
  computed: {
    sanitizedMarkdown() {
      return DOMPurify.sanitize(this.md.render(this.contents), {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target']
      });
    }
  }
};
</script>

<style scoped></style>
